/**
 * @description: 多实例页面渲染
 * @return {*}
 */
export class RenderTree {
  instanceTree: Map<string, Map<string,ComponentItem>> = new Map();
}


